import { lazy } from 'react';

const Tools = lazy(() => import('./AgentToolsPage'));

const AgentToolsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: 'agent/tools',
      element: <Tools />,
    },
  ],
};

export default AgentToolsConfig;
